


















import {Component} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'

@Component
export default class Global extends VueBase {
  showedMessage = false
  showedError = false
  showedConfirm = false
  mounted(): void {
    this.$store.subscribe((mutation) => {
      this.showedMessage = mutation.type === 'setMessage'
      this.showedError = mutation.type === 'setError'
      if (mutation.type === 'setConfirm') {
        this.showedConfirm = !!this.$store.getters.confirm
      }
    })
  }
}
